import React from 'react';
import { useServicesChartsDataContext } from '../../hooks/useServicesChartsDataContext';
import useServicesPerYearTotalChart from './hooks/useServicesPerYearTotalChart';
import { SimpleBars } from '../../../Charts/SimpleBars';
import { years } from '../../../Filters/Filters';

export const ServicesPerYearTotal = ({ isMoney = false, height, decimals = 2 }) => {
    const { module } = useServicesChartsDataContext();
    const { series } = useServicesPerYearTotalChart();

    return (
        <SimpleBars
            series={series}
            values={[]}
            subtitles={years}
            title={`Evolução ${module.sectionTitle} por Ano`}
            isMoney={isMoney}
            height={height}
            decimals={decimals}
            showDataLabels={series.map((item) => item.name).length <= 1}
        />
    );
};
